// Import all API modules from domain folders
import { auditsApi } from './audits';
import { bexioApi } from './bexio';
import { blockTemplatesApi } from './block-templates';
import { companyApi } from './company';
import { documentsApi } from './documents';
import { meetingsApi } from './meetings';
import { presetsApi } from './presets';
import { teamApi } from './team';
import { userApi } from './user';

// Export hooks from domain folders
export * from './audits/hooks';
export * from './bexio';
export * from './block-templates/hooks';
export * from './company/hooks';
export * from './documents/hooks';
export * from './meetings/hooks';
export * from './presets/hooks';
export * from './status/hooks';
export * from './team/hooks';
export * from './user/hooks';

// Export types from original types folder
export * from './types';

// Export axios instance for direct use if needed
export { default as apiClient } from './API';

// Main API object that combines all modules
export const api = {
  audits: auditsApi,
  bexio: bexioApi,
  blockTemplates: blockTemplatesApi,
  company: companyApi,
  documents: documentsApi,
  meetings: meetingsApi,
  presets: presetsApi,
  team: teamApi,
  user: userApi,
} as const;

export default api;
